var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.adData.id),expression:"adData.id"}],staticClass:"springFestival"},[_c('img',{attrs:{"src":_vm.adData.images,"alt":""},on:{"click":_vm.jumpCourseDetail}})])
}
var staticRenderFns = []

export { render, staticRenderFns }